import ClientsTable from 'src/features/userManagement/components/table/ClientsTable';

const Clients = () => {
    return <ClientsTable />;
};

export { Clients };
